﻿cb.define([], function () {
	var ST_st_returnapplylist_VM_Extend = {
		doAction: function (name,viewmodel) {
			if(this[name])
				this[name](viewmodel);
		},
		init: function (viewmodel) {


			//根据单据状态，设置行上的按钮是否显示
			let gridModel = viewmodel.getGridModel();
			gridModel.on('afterSetDataSource', () => {
				const rows = gridModel.getRows();
				const actions = gridModel.getCache('actions');
				const actionsStates = [];
				rows.forEach(data => {
					const actionState = { };
					actions.forEach(action => {
						actionState[action.cItemName] = { visible: false };
						if (data.bizstatus == 0) {
							actionState["btnEdit"] = {visible:true};
							actionState["btnSubmit"] = {visible:true};
							actionState["btnDelete"] = {visible:true};
						}
						if (data.bizstatus == 2) {
							actionState["btnStoreOut"] = {visible:true};
						}
					});
					actionsStates.push(actionState);
				});
				gridModel.setActionsState(actionsStates);
			});

		}
	}

	try {
		module.exports = ST_st_returnapplylist_VM_Extend;
	} catch (error) {

	}
	return ST_st_returnapplylist_VM_Extend;
});



// WEBPACK FOOTER //
// ./src/client/business/ST/ST_st_returnapplylist_VM.Extend.js